import { render } from "./Correos.vue?vue&type=template&id=163f49e7"
import script from "./Correos.vue?vue&type=script&lang=js"
export * from "./Correos.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__